<mat-card>
  <mat-card-header>
    <mat-card-title>
      <div class="header flex flex-row justify-between items-center">
        <div
          [ngClass]="isMoreActions ? 'header-text-short' : 'header-text-wide'"
          class="flex flex-row gap-[16px]"
        >
          <app-features-container-header
            [header]="header"
            [parentComponentSelector]="parentComponentSelector"
          >
            <ng-content header select="[header]"></ng-content>
          </app-features-container-header>
        </div>
        <ng-container *ngIf="isMoreActions">
          <button
            class="not-draggable-link"
            mat-icon-button
            data-at-more-actions
            [matMenuTriggerFor]="moreActionsMenu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </ng-container>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-content select="[feature]"></ng-content>
  </mat-card-content>
  <mat-card-actions class="flex flex-row justify-end items-center">
    <a
      data-at-details-and-settings
      *ngIf="overlayType"
      (click)="onDetails()"
      class="details-btn not-draggable-link flex flex-row justify-start items-center"
      gtm="onOpen"
      gtmAction="{{ header }} details"
      gtmCategory="installationDetails"
    >
      <ng-container *ngIf="actionButtonName; else defaultName">{{ actionButtonName }}</ng-container>
      <ng-template #defaultName>{{
        '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
      }}</ng-template>
      <mat-icon>keyboard_arrow_right</mat-icon></a
    >
  </mat-card-actions>
</mat-card>

<mat-menu xPosition="before" [overlapTrigger]="false" #moreActionsMenu="matMenu">
  <ng-content select="[more-menu]"></ng-content>
</mat-menu>
